import React from "react";

interface SectionDividerProps {
  title: string;
}

const SectionDivider: React.FC<SectionDividerProps> = ({ title }) => {
  return (
    <div className="my-4">
      <h2 className="text-sm font-bold text-gray-700 dark:text-gray-300 mb-2">
        {title}
      </h2>

      <div className="border-t-2 border-gray-300 dark:border-gray-600" />
    </div>
  );
};

export default SectionDivider;
